import { IconArrowDownSmall } from 'ui/icons';
import { IconButton } from 'omakase';
import { IconChevronSmallDown } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { InputAdornment, TextFieldProps } from '@material-ui/core';
import { PatronLocationComponentProps } from './PatronLocationButton';
import { TextField } from 'ui';
import { Theme, css } from '@emotion/react';
import { makeStyles } from '@material-ui/core/styles';
import { useStyles as useSearchLauncherStyles } from 'components/www/availability-search/SearchLauncher';
import React from 'react';
import clsx from 'clsx';

export const usePatronLocationTubeSearchInputStyles = makeStyles((theme) => ({
  input: {
    '& input': {
      cursor: 'pointer',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .MuiInputBase-adornedEnd': {
      paddingRight: 4,
    },
    '& .MuiInputBase-root': {
      backgroundColor: theme.colors.bgDefault,
      cursor: 'pointer',
    },
    '& .MuiInputBase-input[disabled]': {
      color: theme.colors.fgDefault,
      '-webkit-text-fill-color': theme.colors.fgDefault,
      opacity: 1,
    },
    '& .MuiButtonBase-root': {
      paddingRight: theme.spacing(1),
    },
  },
}));

export const PatronLocationTubeSearchInput: React.FunctionComponent<
  PatronLocationComponentProps & Omit<TextFieldProps, 'onClick' | 'InputProps'>
> = ({ loading = false, locationText, onClick }) => {
  const [focused, setFocused] = React.useState(false);
  const searchLauncherClasses = useSearchLauncherStyles({});
  const classes = usePatronLocationTubeSearchInputStyles();

  return (
    <TextField
      aria-haspopup
      className={clsx(
        classes.input,
        searchLauncherClasses.select,
        searchLauncherClasses.gridItemAuto
      )}
      focused={focused}
      label={loading ? '' : 'Location'}
      name="location"
      data-testid="location-text-field"
      InputProps={{
        disabled: loading,
        readOnly: true,
        onClick,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              variant="ghost"
              size="medium"
              aria-label={`Select location`}
              onBlur={() => setFocused(false)}
              onFocus={() => setFocused(true)}
            >
              <IconMigrationUtil
                legacyIcon={
                  <IconArrowDownSmall
                    css={(theme: Theme) => css`
                      color: ${theme.colors.fgDefault};
                      font-size: ${theme.typography.pxToRem(24)} !important;
                    `}
                  />
                }
                newIcon={<IconChevronSmallDown />}
              />
            </IconButton>
          </InputAdornment>
        ),
        className: searchLauncherClasses.field,
      }}
      InputLabelProps={{
        disableAnimation: true,
        shrink: true,
      }}
      // Don't include disabled in here, that's a component-level concern, not just
      // an HTML-element-level concern, and thus belongs in InputProps above.
      // Do take the <input> element out of the tab ordering, though.
      id="city-search-location"
      inputProps={{ 'data-testid': 'location-input', tabIndex: -1 }}
      value={loading ? 'Loading' : locationText}
    />
  );
};
